export const choicesApiOperation = [
  { id: "read", name: "Read" },
  { id: "create", name: "Create" },
  { id: "update", name: "Update" },
  { id: "delete", name: "Delete" },
];

export const choicesFileOperation = [
  { id: "import", name: "Import" },
  { id: "export", name: "Export" },
];

export const choicesHttpMethod = [
  { id: "GET", name: "GET" },
  { id: "POST", name: "POST" },
  { id: "PUT", name: "PUT" },
  { id: "PATCH", name: "PATCH" },
  { id: "DELETE", name: "DELETE" },
];

export const choicesFileType = [
  { id: "Excel", name: "Excel" },
  { id: "CSV", name: "CSV" },
  { id: "JSON", name: "JSON" },
  { id: "XML", name: "XML" },
  { id: "ASC", name: "ASC" },
];
